/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectInstitutionalIdDTO
 */
export interface ProjectInstitutionalIdDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectInstitutionalIdDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectInstitutionalIdDTO
     */
    institution?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInstitutionalIdDTO
     */
    value?: string;
}

/**
 * Check if a given object implements the ProjectInstitutionalIdDTO interface.
 */
export function instanceOfProjectInstitutionalIdDTO(value: object): value is ProjectInstitutionalIdDTO {
    return true;
}

export function ProjectInstitutionalIdDTOFromJSON(json: any): ProjectInstitutionalIdDTO {
    return ProjectInstitutionalIdDTOFromJSONTyped(json, false);
}

export function ProjectInstitutionalIdDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInstitutionalIdDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'institution': json['institution'] == null ? undefined : json['institution'],
                  'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ProjectInstitutionalIdDTOToJSON(json: any): ProjectInstitutionalIdDTO {
    return ProjectInstitutionalIdDTOToJSONTyped(json, false);
}

export function ProjectInstitutionalIdDTOToJSONTyped(value?: ProjectInstitutionalIdDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'institution': value['institution'],
        'value': value['value'],
    };
}


